import React from "react";
//outsource
import { Form, Select } from "antd";

//components

const UserDetailStatus = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;

  const placeholder = "Select status";
  const options = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="active" initialValue={true}>
      <Select
        placeholder={placeholder}
        options={options}
        style={{ width: "100%" }}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default UserDetailStatus;
